/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="16"
        height="19.12"
        viewBox="0 0 16 19.12"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="m8 0 8 2.35v3.28a14.69 14.69 0 0 1-3 8.69 22.82 22.82 0 0 1-4.75 4.61l-.27.18-.27-.18a22.57 22.57 0 0 1-4.75-4.61 14.72 14.72 0 0 1-3-9.1V2.35Zm0 1L1 3.07v2.12a13.72 13.72 0 0 0 2.76 8.48A24.08 24.08 0 0 0 8 17.87a24.14 24.14 0 0 0 4.24-4.21A13.69 13.69 0 0 0 15 5.19V3.07Zm3.19 4.58.71.71-4.57 4.61-2.76-2.76.71-.7 2 2Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'ShieldWithCheckmarkIcon';

export default Icon;
